import type { IncomingBackButtonMessage } from './incoming/backButton';
import type { IncomingKeyboardWillShowMessage } from './incoming/keyboard';
import type { IncomingMissingPermissionsMessage } from './incoming/missingPermissions';
import type { IncomingPhotoCollectionDataMessage } from './incoming/photoCollection';

export type IncomingMessage = {
  readonly type: 'nativeEvent';
  readonly payload:
    | IncomingBackButtonMessage
    | IncomingKeyboardWillShowMessage
    | IncomingMissingPermissionsMessage
    | IncomingPhotoCollectionDataMessage;
};

type IncomingPayload = IncomingMessage['payload'];

export function listenForMessage<
  T extends IncomingPayload['type'],
  U extends (IncomingPayload & { readonly type: T })['data'],
>(type: T, callback: (payload: U) => void): () => void {
  const fn = (event: MessageEvent): void => {
    if (typeof event.data !== 'string') return;

    try {
      const message = JSON.parse(event.data) as IncomingMessage;
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (message.type === 'nativeEvent' && message.payload.type === type) {
        callback(message.payload.data as U);
      }
    } catch {
      // ignore
    }
  };

  window.addEventListener('message', fn);

  return () => {
    window.removeEventListener('message', fn);
  };
}
